import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

import PruebaGratis from "./pages/PruebaGratis";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Demo from "./pages/Demo";
import AppLayout from "./components/AppLayout";
import ExigeCapacidad from "./components/ExigeCapacidad";

import Dashboard from "./pages/Dashboard";
import Configurar from "./pages/Configurar";
import Inbox from "./pages/Inbox";
import Agenda from "./pages/Agenda";
import CRM from "./pages/CRM";
import PatientProfile from "./pages/PatientProfile";
import Recovery from "./pages/Recovery";
import AssistantConfig from "./pages/AssistantConfig";
import Templates from "./pages/Templates";
import Analytics from "./pages/Analytics";
import Onboarding from "./pages/Onboarding";
import OnboardingForm from "./pages/OnboardingForm";
import Doctors from "./pages/Doctors";
import Profile from "./pages/Profile";
import Documents from "./pages/Documents";
import Facturacion from "./pages/Facturacion";
import Metricas from "./pages/Metricas";
import Gastos from "./pages/Gastos";
import Reportes from "./pages/Reportes";
import Colaboradores from "./pages/Colaboradores";
import CambiarPassword from "./pages/CambiarPassword";
import Acceso from "./pages/Acceso";
import RecuperarAcceso from "./pages/RecuperarAcceso";
import BajaCorreo from "./pages/BajaCorreo";
import Reservar from "./pages/Reservar";
import Bienvenida from "./pages/Bienvenida";

function Protected({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <div className="h-screen flex items-center justify-center text-slate-500">Cargando…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  // COL.10 -- una sesión abierta con contraseña temporal NO SIRVE PARA NADA salvo
  // cambiarla, y quien lo impone es el servidor: el token lleva el claim `pwd_temp` y
  // `get_current_user` rechaza todo lo que no esté en `_RUTAS_CON_PASSWORD_TEMPORAL`.
  // Este redirect no protege nada -- evita que la persona recorra un panel donde cada
  // pantalla devuelve 403 sin explicar por qué (DT.71).
  if (user.password_temporal && location.pathname !== "/app/cambiar-password")
    return <Navigate to="/app/cambiar-password" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/prueba-gratis" element={<PruebaGratis />} />
        <Route path="/login" element={<Login />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/onboarding" element={<OnboardingForm />} />
        {/* TEN.4: publicas. /bienvenida es a donde vuelve Stripe tras un alta nueva; /acceso es
            donde el dueño crea su contraseña con el enlace del correo. */}
        <Route path="/bienvenida" element={<Bienvenida />} />
        <Route path="/acceso" element={<Acceso />} />
        <Route path="/recuperar" element={<RecuperarAcceso />} />
        {/* CL.4 R3: pública. El enlace del recordatorio por correo (`/baja-correo?t=`); abrirla
            no da de baja, sólo el botón (POST). */}
        <Route path="/baja-correo" element={<BajaCorreo />} />
        <Route path="/reservar/:slug" element={<Reservar />} />
        <Route
          path="/app/cambiar-password"
          element={
            <Protected>
              <CambiarPassword />
            </Protected>
          }
        />
        <Route
          path="/app"
          element={
            <Protected>
              <AppLayout />
            </Protected>
          }
        >
          {/* 🔴 El ÍNDICE no lleva guardia, y es una decisión medida: /app es donde
              ATERRIZAS al entrar, no una sección a la que quisiste ir -- cortarlo con «no
              tienes acceso» se lo diría a alguien que no pidió nada. Desde COL.11 tiene su
              propia pantalla (`dash-sin-agenda`), que explica lo que pasa y remite al menú,
              y el resto del Dashboard (los accesos rápidos de pacientes) sigue sirviendo. */}
          <Route index element={<Dashboard />} />
          <Route path="configurar" element={<ExigeCapacidad cap="configuracion"><Configurar /></ExigeCapacidad>} />
          <Route path="inbox" element={<ExigeCapacidad ruta="/app/inbox"><Inbox /></ExigeCapacidad>} />
          <Route path="agenda" element={<ExigeCapacidad ruta="/app/agenda"><Agenda /></ExigeCapacidad>} />
          <Route path="pacientes" element={<ExigeCapacidad ruta="/app/pacientes"><CRM /></ExigeCapacidad>} />
          <Route path="pacientes/:id" element={<ExigeCapacidad cap="pacientes"><PatientProfile /></ExigeCapacidad>} />
          <Route path="recuperacion" element={<ExigeCapacidad cap="pacientes"><Recovery /></ExigeCapacidad>} />
          <Route path="asistente" element={<ExigeCapacidad ruta="/app/asistente"><AssistantConfig /></ExigeCapacidad>} />
          <Route path="plantillas" element={<ExigeCapacidad ruta="/app/plantillas"><Templates /></ExigeCapacidad>} />
          <Route path="analitica" element={<ExigeCapacidad ruta="/app/analitica"><Analytics /></ExigeCapacidad>} />
          <Route path="onboarding" element={<ExigeCapacidad ruta="/app/onboarding"><Onboarding /></ExigeCapacidad>} />
          <Route path="doctores" element={<ExigeCapacidad ruta="/app/doctores"><Doctors /></ExigeCapacidad>} />
          {/* ⚠️ Sin guardia A PROPÓSITO: el perfil propio no exige ninguna capacidad
              (no está en `nav[]`), sólo sesión iniciada. Su ausencia aquí es una
              decisión, no un hueco del censo. */}
          <Route path="perfil" element={<Profile />} />
          <Route path="documentos" element={<ExigeCapacidad ruta="/app/documentos"><Documents /></ExigeCapacidad>} />
          <Route path="facturacion" element={<ExigeCapacidad ruta="/app/facturacion"><Facturacion /></ExigeCapacidad>} />
          <Route path="metricas" element={<ExigeCapacidad ruta="/app/metricas"><Metricas /></ExigeCapacidad>} />
          <Route path="gastos" element={<ExigeCapacidad ruta="/app/gastos"><Gastos /></ExigeCapacidad>} />
          <Route path="reportes" element={<ExigeCapacidad ruta="/app/reportes"><Reportes /></ExigeCapacidad>} />
          <Route path="colaboradores" element={<ExigeCapacidad ruta="/app/colaboradores"><Colaboradores /></ExigeCapacidad>} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AuthProvider>
  );
}
